export default __webpack_public_path__ + "static/media/National Institute of Technology Patna.1065a756.png";